export const DepositModalSkeletonUi: React.FC = () => {
  return (
    <div aria-busy="true" role="status" aria-label="Loading">
      <div className="mb-4 h-8 w-full animate-pulse rounded bg-gray-700" />
      <div className="mb-2 h-6 w-1/3 animate-pulse rounded bg-gray-700" />
      <div className="mb-4 h-8 w-3/4 animate-pulse rounded bg-gray-700" />
      <div className="mb-2 h-8 w-full animate-pulse rounded bg-gray-700" />
    </div>
  );
};
